module.exports = __webpack_public_path__ + "img/ind-icon4.fdf799a5.png";